module.exports = __webpack_public_path__ + "img/logo@2x.11b0d40a.png";